import {
  IItemActions,
  ItemContext,
  IFetchItemsActionPayload
} from './actions.types';
import { IItemData } from '@/models';
import { IItemPaginatedListData } from '@/services';

export const actions: IItemActions = {
  fetchItems(
    context: ItemContext,
    payload: IFetchItemsActionPayload
  ): Promise<void> {
    return this.$services.item
      .fetchItems(payload.page, payload.search, payload.snapshot)
      .then((itemData: IItemPaginatedListData) => {
        context.commit('SET_ITEMS', itemData.results);
        context.commit('SET_COUNT', itemData.count);
      });
  },

  fetchItem(context: ItemContext, payload: string): Promise<void> {
    return this.$services.item.fetchItem(payload).then((item: IItemData) => {
      const index = context.state.items.findIndex(
        (v: IItemData) => v.item === item.item
      );
      if (index === -1) {
        context.commit('ADD_ITEM', item);
        context.commit('INCREMENT_COUNT');
      } else {
        context.commit('UPDATE_ITEM', item);
      }
    });
  },

  createItem(context: ItemContext, payload: IItemData): Promise<void> {
    return this.$services.item.createItem(payload).then((item: IItemData) => {
      context.commit('ADD_ITEM', item);
      context.commit('INCREMENT_COUNT');
    });
  },

  updateItem(context: ItemContext, payload: IItemData): Promise<void> {
    return this.$services.item.updateItem(payload).then((item: IItemData) => {
      const index = context.state.items.findIndex(
        (v: IItemData) => v.item === item.item
      );
      if (index === -1) {
        context.commit('ADD_ITEM', item);
        context.commit('INCREMENT_COUNT');
      } else {
        context.commit('UPDATE_ITEM', item);
      }
    });
  },

  deleteItem(context: ItemContext, payload: string): Promise<void> {
    return this.$services.item.deleteItem(payload).then(() => {
      context.commit('REMOVE_ITEM', payload);
      context.commit('DECREMENT_COUNT');
    });
  },

  uploadItemFile(context: ItemContext, payload: File): Promise<void> {
    return this.$services.item.uploadItemFile(payload).then(() => {});
  },

  exportItems(context: ItemContext): Promise<void> {
    return this.$services.item.exportItems();
  }
};
